var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"suaw-avatar",class:['suaw-avatar--' + _vm.avatarColor, 'suaw-avatar--' + _vm.size, _vm.className]},[(!_vm.isLoading && _vm.hasImage)?_c('img',{staticClass:"suaw-avatar__image",attrs:{"src":_vm.url,"alt":`Avatar of ${_vm.displayName}`}}):_c('p',{staticClass:"suaw-avatar__text"},[_vm._v(_vm._s(_vm.avatarInitials))])])
}
var staticRenderFns = []

export { render, staticRenderFns }